export const SOURCE_STYLES = {
  direct: { label: "Direct", color: "#C5A880" },
  airbnb: { label: "Airbnb", color: "#FF5A5F" },
  "booking.com": { label: "Booking.com", color: "#2563EB" },
  table: { label: "Table", color: "#3F7D58" },
  checkin: { label: "Check-in", color: "#0F766E" },
  other: { label: "Other channel", color: "#6B7280" },
};

export const sourceStyle = (s) => SOURCE_STYLES[s] || (s?.includes("booking") ? SOURCE_STYLES["booking.com"] : SOURCE_STYLES.other);

export const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
export const mondayOf = (d) => { const x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); return addDays(x, -((x.getDay() + 6) % 7)); };

// last occupied night for multi-day stays (checkout day is exclusive)
export const lastDay = (e) => (e.end > e.start && e.source !== "direct" && e.source !== "table" ? ymd(addDays(new Date(`${e.end}T00:00:00`), -1)) : e.end);

export function SourceLegend() {
  return (
    <div className="flex flex-wrap gap-3 text-xs text-muted-foreground" data-testid="calendar-legend">
      {Object.entries(SOURCE_STYLES).map(([k, v]) => (
        <span key={k} className="flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-sm" style={{ backgroundColor: v.color }} />{v.label}</span>
      ))}
    </div>
  );
}

export function EventRow({ e }) {
  const st = sourceStyle(e.source);
  return (
    <div className="p-3 flex items-center justify-between gap-3" data-testid={`cal-event-${e.id}`}>
      <div className="flex items-center gap-3 min-w-0">
        <span className="w-1 self-stretch rounded-full" style={{ backgroundColor: st.color }} />
        <div className="min-w-0">
          <p className="text-sm text-foreground font-medium truncate">{e.title}{e.time ? ` · ${e.time}` : ""}</p>
          <p className="text-xs text-muted-foreground truncate">{st.label}{e.guest && e.guest !== e.title ? ` · ${e.guest}` : ""}{e.room ? ` · ${e.room}` : ""}{e.end !== e.start ? ` · ${e.start} → ${e.end}` : ""}</p>
        </div>
      </div>
      {e.status && <span className="text-[10px] uppercase tracking-widest text-muted-foreground shrink-0">{e.status.replace("_", " ")}</span>}
    </div>
  );
}
